<h3 class="insurance-imic__header">Groene kaart</h3>
<ins-insurance-imic-car
    *ngIf="purchasedProduct?.productId === productIdEnum.Car"
    [purchasedProduct]="purchasedProduct"
></ins-insurance-imic-car>
<ins-insurance-imic-motorcycle
    *ngIf="purchasedProduct?.productId === productIdEnum.Motorcycle"
    [purchasedProduct]="purchasedProduct"
></ins-insurance-imic-motorcycle>
<ins-insurance-imic-moped
    *ngIf="purchasedProduct?.productId === productIdEnum.Moped"
    [purchasedProduct]="purchasedProduct"
></ins-insurance-imic-moped>
<ins-insurance-imic-caravan
    *ngIf="purchasedProduct?.productId === productIdEnum.Caravan"
    [purchasedProduct]="purchasedProduct"
></ins-insurance-imic-caravan>
